import React from "react";
import Container from "../container/container";

import styles from "./header.module.css";

export default () => (
  <header className={styles.header}>
    <div className="wrapper">
      <Container>
        <a href="/" title="Track your Diabetes">
          <img
            alt="Sukar Diabetes Tracking"
            src="/images/sukar-diabetes-app.svg"
            height="44"
            width="156"
          />
        </a>
      </Container>
    </div>
  </header>
);
